const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDrivers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0459955,0,0,0.0459955,11,11)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "driver",
    transform: "matrix(1,0,0,1,-228.283,-228.283)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M228.291,243.089C214.684,243.089 203.605,254.152 203.605,267.751C203.605,281.35 214.684,292.421 228.291,292.421C241.89,292.421 252.969,281.35 252.969,267.751C252.969,254.152 241.89,243.089 228.291,243.089Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.207,278.961C316.73,245.813 359.982,228.735 416.614,227.946C416.24,209.047 413.086,190.831 407.518,173.688C346.481,214.526 286.427,228.345 233.282,228.345C139.438,228.345 67.175,185.54 49.032,173.729C43.692,190.206 40.66,207.715 40.082,225.825C98.746,225.833 143.291,243.058 172.488,276.986C218.569,330.553 211.009,406.978 209.449,419.228C215.651,419.838 221.926,420.171 228.291,420.171C235.956,420.171 243.532,419.651 250.978,418.757C249.051,401.092 244.483,329.756 288.207,278.961ZM395.35,198.992L398.471,206.251L338.824,231.897L335.695,224.654L395.35,198.992ZM121.88,231.896L62.232,206.25L65.345,198.991L124.984,224.653L121.88,231.896ZM195.72,267.751C195.72,249.795 210.319,235.188 228.291,235.188C246.247,235.188 260.862,249.795 260.862,267.751C260.862,285.715 246.247,300.322 228.291,300.322C210.319,300.322 195.72,285.715 195.72,267.751Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.283,0.004C102.412,0.004 0,102.408 0,228.279C0,354.158 102.412,456.562 228.283,456.562C354.154,456.562 456.566,354.15 456.566,228.279C456.566,102.408 354.154,0.004 228.283,0.004ZM228.283,428.055C120.035,428.055 31.954,339.998 31.954,231.742C31.954,123.486 120.035,35.412 228.283,35.412C336.523,35.412 424.596,123.477 424.596,231.733C424.596,339.989 336.523,428.055 228.283,428.055Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrivers);
export default __webpack_public_path__ + "static/media/drivers.847f4db3ea031f2c4a244f7374c6a68c.svg";
export { ForwardRef as ReactComponent };